import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Radio } from 'semantic-ui-react';
import styles from '../../Form.scss';
import { FloatingLabelInput as Input } from '../../../../Elements';

const RadioWidget = ({ editing, schema, uiSchema, formData, onChange }) => {
  const onRadioLabelChange = (e, index) => {
    const schemaEnum = schema.enum.slice();
    schemaEnum[index] = e.target.value;
    onChange({
      schema: Object.assign({}, schema, { enum: schemaEnum }),
      uiSchema,
      formData
    });
  };
  const addOption = () => {
    const schemaEnum = schema.enum.slice();
    schemaEnum.push(`Option ${schemaEnum.length + 1}`);
    onChange({
      schema: Object.assign({}, schema, { enum: schemaEnum }),
      uiSchema,
      formData
    });
  };

  const removeOption = (index) => {
    const schemaEnum = schema.enum.slice();
    schemaEnum.splice(index, 1);
    onChange({
      schema: Object.assign({}, schema, { enum: schemaEnum }),
      uiSchema,
      formData
    });
  };

  return (
    <div className={styles.responseField}>
      {schema.enum.map((option, index) => (
        <div key={index}>
          {editing &&
            <div style={{ display: 'flex' }}>
              <div>
                <Radio checked={false} style={{ paddingTop: '0.5em', marginRight: '0.5em' }} />
              </div>
              <div style={{ flex: 1 }}>
                <Input
                  onChange={(e) => onRadioLabelChange(e, index)}
                  value={option} name={`option-${index}`}
                  inline
                  width='100%'
                />
              </div>
              {index > 1 &&
                <span
                  className={styles.deleteItemRelative}
                  onClick={() => removeOption(index)}
                >
                  <Icon name='close' />
                </span>}
              {index <= 1 && <span style={{ width: '1.5em' }}></span>}
            </div>}
          {!editing &&
            <Radio checked={false} style={{ paddingBottom: '1em' }} label={option} />}
        </div>
      ))}
      {editing && <a onClick={addOption}>+ Add Option</a>}
    </div>
  );
};

RadioWidget.propTypes = {
  editing: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  schema: PropTypes.object.isRequired,
  uiSchema: PropTypes.object,
  formData: PropTypes.string
};

export default RadioWidget;



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Builder/Widgets/Radio.js